import {create} from "zustand";

export interface RefreshIndicatorState {
    requests: Set<{ label?: string }>;
    connectionStatus: 'connected' | 'disconnected' | 'no-internet';
    setConnectionStatus: (status: 'connected' | 'disconnected' | 'no-internet') => void;
    addRequest: (label?: string) => () => void;
}

export const useRefreshIndicatorStore = create<RefreshIndicatorState>()(set => {
    return ({
        requests: new Set(),
        connectionStatus: 'disconnected',
        setConnectionStatus: status => set({connectionStatus: status}),
        addRequest: (label?: string) => {
            const request = {label};
            set(prevState => {
                const newRequests = new Set(prevState.requests);
                newRequests.add(request);
                return {requests: newRequests};
            });
            return () => {
                set(prevState => {
                    const newRequests = new Set(prevState.requests);
                    newRequests.delete(request);
                    return {requests: newRequests};
                });
            };
        },
    });
});

export async function withRefreshIndicator<T>(fn: () => Promise<T>): Promise<T> {
    const removeRequest = useRefreshIndicatorStore.getState().addRequest();
    try {
        return await fn();
    } finally {
        removeRequest();
    }
}